import styled from '@emotion/styled';
import done from 'ud-ui/components/icon/icons/done.svg';

export const CustomCheckbox = styled.div`
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
  }
`;

export const CheckboxLabel = styled.label`
  cursor: pointer;
  display: block;

  &:focus > div {
    border: 1px solid ${({ theme }) => theme.colors.DarkYellow};
  }

  &:hover > input:not(:disabled) + div {
    background-color: ${({ theme }) => theme.colors.DarkYellowAlpha20};
    border: 1px solid ${({ theme }) => theme.colors.DarkYellow};
  }
`;

export const CheckboxInput = styled.input<{ size?: number }>`
  & + div {
    display: block;
    width: ${({ size }) => size || 24}px;
    height: ${({ size }) => size || 24}px;
    background-color: ${({ theme }) => theme.colors.WhiteGray20};
    border-radius: 4px;
    border: 1px solid transparent;
  }

  &:focus + div {
    border: 1px solid ${({ theme }) => theme.colors.DarkYellow};
  }

  &:checked + div {
    background-color: ${({ theme }) => theme.colors.DarkYellow};
    border: 1px solid transparent;

    &:after {
      background-image: url(${done});
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px;
      top: -1px;
      left: -1px;
    }
  }

  &:disabled + div {
    background-color: ${({ theme }) => theme.colors.WhiteGray10};
    cursor: not-allowed;
  }
`;
